import capitalize from './capitalize'

/**
 * Converts graphql transmission enumeration values to display values.
 * @param {String} value
 * @return {String}
 */
export default value => {
  if (!value || value === 'DSG') return value
  return capitalize(value, { delimiter: '_' })
}
